import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-album-slider',
  templateUrl: './section-album-slider.component.html',
  styleUrls: ['./section-album-slider.component.css']
})
export class SectionAlbumSliderComponent implements OnInit {

  @Input() sectionInfo;
  
  constructor() { }

  ngOnInit(): void {
  }

}
